<template>
  <div class="change-password-page">
    <main class="change-password-shell">
      <button class="back-btn" type="button" @click="$router.back()">
        <img class="back-icon" src="@/static/icon/left.png" alt="" />
        <span>{{ $t('common.back') }}</span>
      </button>

      <section class="password-card">
        <header class="card-header">
          <span class="security-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <rect x="5" y="10" width="14" height="10" rx="2.5" />
              <path d="M8 10V7a4 4 0 0 1 8 0v3" />
              <path d="M12 14.5v2" />
            </svg>
          </span>
          <h1>{{ $t('settings.changePassword') }}</h1>
          <p>{{ $t('settings.changePasswordDesc') }}</p>
        </header>

        <van-form class="password-form" @submit="handleSubmit">
          <!-- <van-field
            v-model="form.oldpassword"
            name="oldpassword"
            type="password"
            :label="$t('settings.oldPassword')"
            :placeholder="$t('settings.oldPasswordPlaceholder')"
            autocomplete="current-password"
            clearable
          /> -->
          <van-field
            v-model="form.password"
            name="password"
            type="password"
            :label="$t('settings.newPassword')"
            :placeholder="$t('settings.newPasswordPlaceholder')"
            autocomplete="new-password"
            clearable
          />
          <van-field
            v-model="form.repassword"
            name="repassword"
            type="password"
            :label="$t('settings.confirmPassword')"
            :placeholder="$t('settings.confirmPasswordPlaceholder')"
            autocomplete="new-password"
            clearable
          />

          <button
            class="save-btn"
            type="submit"
            :disabled="submitting || !canSubmit"
            :class="{ disabled: submitting || !canSubmit }"
          >
            {{ submitting ? $t('settings.saving') : $t('settings.save') }}
          </button>
        </van-form>
      </section>
    </main>
  </div>
</template>

<script>
import { changePwd } from '@/apis/user.js'
import { Toast } from 'vant'

export default {
  name: 'ChangePassword',
  data() {
    return {
      submitting: false,
      form: {
        oldpassword: '',
        password: '',
        repassword: ''
      }
    }
  },
  computed: {
    canSubmit() {
      return Boolean(this.form.password && this.form.repassword)
    }
  },
  methods: {
    async handleSubmit() {
      const error = this.validateForm()

      if (error) {
        Toast(error)
        return
      }

      try {
        this.submitting = true
        const response = await changePwd({
          oldpassword: this.form.oldpassword,
          password: this.form.password,
          repassword: this.form.repassword
        })

        if (!this.isSuccessResponse(response)) {
          Toast(this.getResponseMessage(response) || this.$t('settings.passwordUpdateFailed'))
          return
        }

        Toast(this.getResponseMessage(response) || this.$t('settings.passwordUpdateSuccess'))
        this.form.oldpassword = ''
        this.form.password = ''
        this.form.repassword = ''
        this.$router.back()
      } catch (error) {
        Toast(this.getResponseMessage(error && error.response && error.response.data) || this.$t('settings.passwordUpdateFailed'))
      } finally {
        this.submitting = false
      }
    },
    validateForm() {
      if (!this.form.password || !this.form.repassword) {
        return this.$t('settings.passwordRequired')
      }

      if (this.form.password.length < 6) {
        return this.$t('auth.invalidPassword')
      }

      if (this.form.password !== this.form.repassword) {
        return this.$t('auth.passwordMismatch')
      }

      return ''
    },
    isSuccessResponse(response) {
      const code = response && response.code !== undefined ? String(response.code) : ''
      return code === '1' || code === '200' || code === '2000' || Boolean(response && response.data)
    },
    getResponseMessage(response) {
      if (!response) return ''
      return response.msg || response.message || response.error || ''
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

.change-password-page {
  min-height: 100vh;
  background:
    radial-gradient(circle at 16% 10%, rgba(255, 255, 255, 0.95), transparent 28%),
    linear-gradient(145deg, #f7f8fb 0%, #eef1f5 48%, #ffffff 100%);
  color: #111111;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", sans-serif;
}

.change-password-shell {
  width: 100%;
  max-width: 450px;
  min-height: 100vh;
  margin: 0 auto;
  padding: 26px 18px 34px;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1d1d1f;
  font: inherit;
  font-size: 15px;
  font-weight: 500;
}

.back-icon {
  width: 16px;
  height: 16px;
}

.password-card {
  margin-top: 24px;
  padding: 28px 22px 24px;
  border: 1px solid rgba(255, 255, 255, 0.88);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.76);
  backdrop-filter: blur(22px);
  -webkit-backdrop-filter: blur(22px);
  box-shadow: 0 18px 44px rgba(35, 42, 55, 0.1);
}

.card-header {
  text-align: center;
}

.security-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  margin-bottom: 16px;
  border-radius: 17px;
  background: #111111;
  color: #ffffff;
  box-shadow: 0 14px 30px rgba(17, 17, 17, 0.16);
}

.security-icon svg {
  width: 30px;
  height: 30px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.card-header h1 {
  margin: 0;
  color: #111111;
  font-size: 30px;
  font-weight: 750;
  line-height: 1.15;
  letter-spacing: 0;
}

.card-header p {
  max-width: 280px;
  margin: 10px auto 0;
  color: #6e6e73;
  font-size: 14px;
  line-height: 1.55;
  letter-spacing: 0;
}

.password-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 26px;
}

.password-form ::v-deep .van-cell {
  display: flex;
  align-items: center;
  min-height: 54px;
  padding: 9px 14px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.password-form ::v-deep .van-cell::after {
  display: none;
}

.password-form ::v-deep .van-field__label {
  display: flex;
  align-items: center;
  width: 82px;
  color: #3a3a3c;
  font-size: 14px;
  font-weight: 600;
}

.password-form ::v-deep .van-field__body {
  display: flex;
  align-items: center;
  min-height: 34px;
}

.password-form ::v-deep .van-field__control {
  color: #111111;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0;
}

.password-form ::v-deep .van-field__control::placeholder {
  color: #b0b0b7;
}

.save-btn {
  width: 100%;
  height: 52px;
  margin-top: 8px;
  border: 0;
  border-radius: 999px;
  background: #111111;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  box-shadow: 0 16px 30px rgba(17, 17, 17, 0.18);
}

.save-btn:active {
  transform: translateY(1px);
}

.save-btn.disabled {
  background: #c7c7cc;
  box-shadow: none;
}

@media (max-width: 380px) {
  .change-password-shell {
    padding-right: 14px;
    padding-left: 14px;
  }

  .password-card {
    padding: 26px 16px 22px;
    border-radius: 24px;
  }

  .card-header h1 {
    font-size: 27px;
  }

  .password-form ::v-deep .van-field__label {
    width: 74px;
  }
}
</style>
